import { Arrows, InputPanelMeas } from './models';

export const ARROWS: Arrows = {
  ArrowLeft: 1,
  ArrowUp: 2,
  ArrowRight: 3,
  ArrowDown: 4,
};

export const DEFAULT_INPUT_PANEL_MEAS: InputPanelMeas = {
  width: 'min(16.7vmin, 75px)',
  height: 'min(16.7vmin, 75px)',
  border: 'min(0.67vmin, 3px)',
  margin: 'min(0.67vmin, 3px)',
  space: 'min(2.68vmin, 12px)', // From 2 margins plus 2 borders
};
